<template>
  <Card class="filters-container">
    <div class="filters-header">FILTER BY:</div>
    <div class="filter-options">
      <h5>Category</h5>
      <CategoryNav />
    </div>
  </Card>
</template>

<script>
import CategoryNav from "./CategoryNav.vue";
import Card from "../UI/Card.vue";
export default {
  name: "Filters",
  components: {
    Card,
    CategoryNav,
  },
};
</script>

<style>
.filters-container {
  display: flex;
  flex-direction: column;
}

.filters-header {
  padding: 0.75rem 15px;
  font-weight: bold;
  background: var(--rofix-lighter-gray);
}

.filter-options {
  padding: 0.75rem;
}

.price-slider {
  width: 100%;
}
</style>
